import { createTheme } from "@mui/material/styles";

const gogiDarkTheme = createTheme({
  palette: {
    mode: "dark",
    background: {
      default: "#090a0f",
      paper: "#11131a",
    },
    primary: {
      main: "#6b9fff",
    },
    secondary: {
      main: "#8b919a",
    },
    text: {
      primary: "#e8eaed",
      secondary: "#8b919a",
    },
    divider: "#252a38",
    success: {
      main: "#4ade80",
    },
    error: {
      main: "#f87171",
    },
    warning: {
      main: "#fbbf24",
    },
  },
  typography: {
    fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
    fontSize: 14,
    h1: { fontWeight: 700, letterSpacing: "-0.02em" },
    h2: { fontWeight: 700, letterSpacing: "-0.02em" },
    h3: { fontWeight: 600, letterSpacing: "-0.02em" },
    h4: { fontWeight: 600, letterSpacing: "-0.02em" },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },
    body1: { fontSize: "0.875rem" },
    body2: { fontSize: "0.8125rem" },
  },
  shape: {
    borderRadius: 8,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
          border: "1px solid #252a38",
          boxShadow: "none",
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none",
        },
      },
    },
    MuiDivider: {
      styleOverrides: {
        root: {
          borderColor: "#252a38",
        },
      },
    },
  },
});

export default gogiDarkTheme;
